var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.modelValue || _vm.value)?_c('div',{class:_setup.componentClasses},[_c('div',{staticClass:"stk-drawer-backdrop",on:{"click":_setup.emitClose}}),_vm._v(" "),_c('div',{staticClass:"stk-drawer-side"},[_vm._t("default")],2)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }